
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAB1UExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/3ej//L3/////4+0/+bv/83e/5u8/9rm/0WC/4Os /1GK/2qb/7TN/2mb/5y9/8DV/9nm/83d/7TM/wAAAN7h75gAAAASdFJOUwBAj9/PnyAQkI/PQM/P jxDfP5LbpTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5wwEAzki VKWJywAAALdJREFUKM+VktsSgiAURU8oXrKyyBtpgV3+/xcTlEThONN62sOazcDMBhjYkYAtCGkE I3HCPKSxdiHzslc2YQgpQMRQMqC4JHDAZQBsg1lei3Kk8si64Zpb0TqyK+9jeJTckbUwqflVYV20 q+AUrSqYYielTq2UvXnwJLn6w1MloRJ35UvficiZP2S1lMsHteJt8TFfWU3L5ggnXFLIcDnME62S YX351jQh93ZJPG0+oqv2mVzU+RebYzaxyXa8FgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0xMi0w NFQwMjozMjoxNSswMDowMJPflswAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMtMTItMDRUMDI6MzI6 MTUrMDA6MDDigi5wAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIzLTEyLTA0VDAzOjU3OjM0KzAw OjAwgs/b5AAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    